// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"612afeb7","104":"ad540fd3","305":"24ce472e","390":"4c67e62b","489":"5150df37","521":"17d1567f"}[chunkId] + ".chunk.js";
};